import React from "react";
import {Translate} from "../../util/translation.util";

export const PaginatorTotal: React.FC<{ from: number, to: number, total: number }> = ({from, to, total}) => {

    return (
            <React.Fragment>
                <div><Translate message={"global.paginator_total"} params={{ from:from.toString(), to:to.toString(), total:total.toString() }}/></div>
            </React.Fragment>

    )
}